import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useCanAccessRoute } from '@omnea-app/fe-authz/useRouteAccess'
import { INTEGRATION_SETTINGS_BASE_PATH } from '@omnea-app/fe-organisation-integrations/basePaths'
import { useGetOrgIntegrationConfig } from '@omnea-app/fe-organisation-integrations/useGetOrgIntegrationConfig'
import { useListOrganisationIntegrations } from '@omnea-app/fe-organisation-integrations/useListOrganisationIntegrations'
import { globalIntegrationsMetadata } from '@omnea-app/packages/universal/integrations/globalIntegrations'
import { isDefined } from '@omnea-app/packages/universal/type-guards/isDefined'

export const useNetsuiteMergeMigrationBannerInfo = (): {
  shouldShowBanner: boolean
  href?: string
  integrationTitle?: string
} => {
  const { user } = useAuthenticatedUser()
  // Super admins can still be denied the IT config area, and the banner links straight into it
  const canOpenIntegrationSettings = useCanAccessRoute('settingsIntegrations')
  const canSeeBanner = user.isSuperAdmin && canOpenIntegrationSettings

  const { data: netsuiteIntegrations } = useListOrganisationIntegrations({ enabled: canSeeBanner, type: 'netsuite' })
  // No org runs more than one NetSuite instance yet, and a second one can only be set up with direct auth
  const netsuiteIntegration = netsuiteIntegrations?.[0]

  const { data: orgIntegrationConfig } = useGetOrgIntegrationConfig({
    orgIntegrationId: netsuiteIntegration?.id ?? '',
    options: { skip: !isDefined(netsuiteIntegration) },
  })

  if (!canSeeBanner || !isDefined(netsuiteIntegration)) return { shouldShowBanner: false }

  const { mergeConnected = false, clientCredentialsProvided = false } = orgIntegrationConfig?.authStatus ?? {}

  return {
    shouldShowBanner: mergeConnected && !clientCredentialsProvided,
    href: `${INTEGRATION_SETTINGS_BASE_PATH}/${netsuiteIntegration.id}`,
    integrationTitle: netsuiteIntegration.name ?? globalIntegrationsMetadata.netsuite.title,
  }
}
